module.exports = __webpack_public_path__ + "static/media/github_logo.0bb6cf15.svg";